export default {
  serverURI: '',
  fixedLayout: false,
  hideLogoOnMobile: false,
  project: 'sd312022',
  loginNameProject: 'BIODIGESTOR',
  sideNameProject: 'BIODIGESTOR',
  exibirGraficoInicial: false,
  iconeInterno: '../static/img/bi-logo-archea-biogas2.svg',
  grafico: {
    parametro: 'BiodigestorVazaoAcumulada',
    titulo: 'Gás consumido a partir do dia',
    label: 'Gás consumido (m³)'
  },
  idioma: 'Pt-Br'
}



// WEBPACK FOOTER //
// ./src/config/index.js